import { createAction, props } from '@ngrx/store';

import { AppSettings } from 'app/features/settings/models/app-settings';

export const preloadSettings = createAction('[Settings] Preload Settings');

export const updateAppSettings = createAction(
    '[Settings] Update App Settings',
    props<{ settings: AppSettings }>(),
);

export const updateSettingsSuccess = createAction('[Settings] Update Settings Success');
